<template>
    <div>
        <div class="grid grid-cols-5 w-full">
            <div class="col-span-2 p-2">
                <div class="">
                    <div class="flex mb-2 items-center">
                        <CustomInput v-model="searchTerm" class="w-full" type="text" placeholder="Boogi"
                            label="Retailer" />

                        <CustomButton @click="getRetailerBySearch(0, 25, searchTerm)" class="mt-5 ml-1" text="Search"
                            type="action" />
                    </div>

                    <EasyDataTable :headers="headersTable1" :items="retailers" :loading="loading"
                        v-model:server-options="serverOptions" :server-items-length="serverItemsLength"
                        :hide-footer="false" :no-hover="false">
                        <template #loading>
                            <div class="p-4 w-full flex justify-center">
                                <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                            </div>
                        </template>
                        <template #empty-message>
                            <div class="flex justify-center py-4">
                                <div
                                    class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                    <p class="text-sm mr-2">No results</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                    </svg>
                                </div>
                            </div>
                        </template>
                        <template #header-action="header">
                            <div class="w-full text-right">
                                {{ header.text }}
                            </div>
                        </template>

                        <template #item-action="retailer">
                            <div class="flex justify-end items-center py-1 gap-1">
                                <CustomButton small text="Select" @click="selectedRetailer = retailer" />
                            </div>
                        </template>
                    </EasyDataTable>
                </div>
                <div v-if="searched">

                    <div class="-mt-3">
                        <div class="border-b border-gray-400 h-10 h-10">
                        </div>
                        <p class="flex justify-center items-center h-10 -mt-5">
                            <span class="px-2 bg-white text-sm">Or</span>
                        </p>
                    </div>

                    <CustomButton text="Create a retailer" @click="createRetailerButton = !createRetailerButton; clearRetailers()" />

                    <div v-if="createRetailerButton">
                    <p class=" mt-1 text-md font-medium">Create new retailer</p>

                    <CustomInput v-model="createRetailer.retailerName" class="w-full mt-3" type="text"
                        placeholder="Selfridges" label="Retailer name" />
                    <CustomInput v-model="createRetailer.retailerWebsite" class="w-full mt-3" type="text"
                        placeholder="https://selfridges.com" label="Retailer website" />
                    <CustomInput class="w-full mt-3" type="file" label="Retailer Logo" @change="uploadFile"
                        ref="fileInput" accept=".png" />

                    <CustomInput v-model="createRetailer.monthlyWebVisits" class="w-full mt-3" type="integer" placeholder="100,000" label="Retailer Popularity (measured in webviews a month)"  />
                    <label class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer"><a href="https://ahrefs.com/traffic-checker" target="_blank">Use this link to find popularity</a> </label>                    
                    
                    <CustomSelect v-model="createRetailer.goodForBusiness" class="w-full mt-2" :options="trueOrFalse" label="Does this retailer service businesses" />
                    <CustomSelect v-model="createRetailer.luxury" class="w-full mt-2" :options="trueOrFalse" label="Does this retailer sell luxury goods" />
                    <CustomSelect v-model="createRetailer.subscription" class="w-full mt-2" :options="trueOrFalse" label="Does this retailer sell a subscription based product" />

                    <CustomButton
                        :disabled="createRetailer.monthlyWebVisits  == undefined || createRetailer.goodForBusiness == undefined || createRetailer.luxury  == undefined || createRetailer.subscription  == undefined || createRetailer.retailerName == '' || createRetailer.retailerWebsite == '' || createRetailer.retailerLogoFile == ''"
                        @click="$emit('formSubmitCreated', createRetailer)" class="mt-5 ml-1" text="Save"
                        type="action" />
                    </div>
                </div>
            </div>
            <div v-if="retailData.retailerName != ''" class="col-span-3 p-2 justify-center">
                <div class="bg-[#F5F2FB] px-3 py-4 rounded-lg bg-opacity-60 grid gap-2">
                    <div 
                        v-if="retailData.retailerName != ''"
                        class="flex justify-start items-center px-1 py-1 gap-2 w-full bg-white shadow-sm rounded-xl  border border-gray-300">
                        <img class="object-contain w-[50px] h-[50px] rounded-lg border border-gray-200 bg-white"
                            :src="retailData.retailerLogo" />
                        <div class="">
                            <p class="font-semibold text-lg">{{ retailData.retailerName }}</p>
                        </div>
                    </div>

                    <div v-if="retailData.obCompatiable == true" class="bg-green-50 border border-green-300 py-2 px-3 w-full bg-white shadow-sm rounded-lg">
                        <p class="text-sm font-medium text-green-900">{{retailData.retailerName}} is open banking compatible</p>
                        <p class="text-xs text-green-900">Please move to the <span class="font-medium">Create channels</span> stage to continue adding this offer.</p>
                    </div>
                    <div v-else-if="retailData.obCompatiable == false" class="bg-red-200 border border-red-300 py-2 px-3 w-full bg-white shadow-sm rounded-lg">
                        <p class="text-sm font-medium text-red-900">{{retailData.retailerName}} is not open banking compatible</p>
                        <p class="text-xs text-red-900">Please move to the <span class="font-medium">Create channels</span> stage to continue adding this offer.</p>
                    </div>
                    <div v-else class="bg-yellow-50 border border-yellow-300 py-2 px-3 w-full bg-white shadow-sm rounded-lg">
                        <p class="text-sm font-medium text-yellow-900">We're not sure if {{retailData.retailerName}} is compatible with open banking</p>
                        <p class="text-xs text-yellow-900">Please confirm transaction compatibility on the next stage.</p>
                    </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>

import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import CustomSelect from "../inputs/CustomSelect.vue";
export default {
    name: "retailer-mapping",
    components: {
        CustomInput,
        CustomButton,
        CustomSelect

    },
    props: {
        retailData: {
            type: Object
        }
    },
    data() {
        return {

            createRetailerButton:false,

            trueOrFalse: [
                { id: true, text: "Yes" },
                { id: false, text: "No" },

            ],

            headersTable1: [
                { text: "Name", value: "retailer.retailerName" },
                { text: "Website", value: "retailer.retailerWebsite" },
                { text: "Select retailer", value: "action" },

            ],
            retailers: [

            ],
            loading: false,
            searchTerm: "",
            serverItemsLength: undefined,
            selectedRetailer: undefined,
            searched:false,

            createRetailer: {
                retailerName: "",
                retailerWebsite: "",
                retailerLogoFile: "",
                displayUrl: "",
                monthlyWebVisits:undefined,
                goodForBusiness:undefined,
                luxury:undefined,
                subscription:undefined,
            }

        }
    },
    watch: {
        selectedRetailer(val) {
            this.$emit('formSubmitSelect', val.retailer)
        }
    },
    methods: {

        clearRetailers(){
            this.selected = false
            this.createRetailer = {
                retailerName: "",
                retailerWebsite: "",
                retailerLogoFile: "",
                displayUrl: "",
                monthlyWebVisits:undefined,
                goodForBusiness:undefined,
                luxury:undefined,
                subscription:undefined,
            }
        },

        uploadFile: function () {
            // const file = event.target.files[0];
            this.createRetailer.retailerLogoFile = event.target.files[0]
            this.createRetailer.displayUrl = URL.createObjectURL(this.createRetailer.retailerLogoFile)

        },

        async getRetailerBySearch(page, size, retailerSearch) {
            this.loading = true
            
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer-search?page=${page}&size=${size}&search=${retailerSearch}&category=`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.searched = true
                    this.retailers = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch {
                return
            }
        },
    }
}

</script>